import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMe, selectAdvertisings, selectAdvertisingsCount, selectAdvertisingsOrderBy, selectAdvertisingsFilter, selectAdvertisingsPagination } from '../redux/selectors';
import { useTranslation } from 'react-i18next';
import { setSmartMenu, fetchMe, updateSmartMenu, fetchAdvertisings, setAdvertisingsFilter, setAdvertisingsOrderBy, setAdvertisingsPagination } from '../redux/actions';
import { useNavigate } from 'react-router-dom';
import { AdvertisingList, SearchBar } from '../components';
import NewAdvertising from '../components/modal/newAdvertising';
import { useModal } from '../hooks/useModal';

const Advertisements = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const me = useSelector(selectMe);
  const advertisings = useSelector(selectAdvertisings);
  const advertisingsCount = useSelector(selectAdvertisingsCount);
  const advertisingsOrderBy = useSelector(selectAdvertisingsOrderBy);
  const filter = useSelector(selectAdvertisingsFilter);
  const pagination = useSelector(selectAdvertisingsPagination)

  const itemsPerPage = 15

  const { show: showA, hide: hideA, RenderModal: RenderModalA } = useModal();
  
  useEffect(() => {
    handleOnSetPagination(null, {activePage: pagination.activePage || 0})
    dispatch(fetchMe())
    dispatch(setSmartMenu({
      buttons: [
        { key: 'add_advertising', name: 'button-add_advertising', icon: 'add', onButtonClick: ()=>showA(true)}
      ],
      navigation: null
    }))
  },[props])

  useEffect(()=>{
    if(me)
      dispatch(updateSmartMenu({
        headline: t('headline-welcome', {givenname: me.givenname})
      }))
  }, [me])
  
  useEffect(()=>{
    dispatch(setAdvertisingsPagination({
      ...pagination,
      totalPages: Math.ceil(advertisingsCount / itemsPerPage)
    }))
  }, [advertisingsCount])
  
  useEffect(()=>{
    let multi = itemsPerPage * (pagination.activePage -1)
    if(pagination.activePage === 1)
      multi = 0
    dispatch(fetchAdvertisings(filter, itemsPerPage, multi, advertisingsOrderBy))
  }, [advertisingsOrderBy])
  
  const handleOnClickAdvertising = async (target) => {
    const { id, title } = target
    navigate(`/advertisings/${id}`)
  }

  const handleOnFilterAdvertisings = async(values) => {
    dispatch(setAdvertisingsFilter(values))
    dispatch(fetchAdvertisings(values, itemsPerPage, 0, advertisingsOrderBy))
  }
  
  const handleOnChangeOrderBy = (e, { value }) => {
    dispatch(setAdvertisingsOrderBy(value))
  }

  const handleOnSetPagination = (e, { activePage }) => {
    let multi = itemsPerPage * (activePage -1)
    if(activePage === 1)
      multi = 0
    dispatch(fetchAdvertisings(filter, itemsPerPage, multi, advertisingsOrderBy))
    dispatch(setAdvertisingsPagination({
      ...pagination,
      activePage: activePage
    }))
  }

  return (
    <article>
      <SearchBar
        show={true}
        currentFilter={filter}
        filterKey={'title'}
        onSearch={handleOnFilterAdvertisings}
        user={me}
      />
      <AdvertisingList
        show={true}
        pagination={pagination}
        onClickEdit={handleOnClickAdvertising}
        onSetPagination={handleOnSetPagination}
        onChangeOrderBy={handleOnChangeOrderBy}
        advertisings={advertisings}
        advertisingsOrderBy={advertisingsOrderBy}
      />
      <RenderModalA>
        <NewAdvertising
          hide={hideA}
        />
      </RenderModalA>
    </article>
  );
}

export default Advertisements;